export default {
	async measurePromiseCompletionTime(promise, startTime, name) {
		await promise
		var endTime = performance.now()
		console.log("Promise '" + name + "' took " + (endTime - startTime)+"ms to settle")
	}
}